import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ApiKeysView } from '@/components/global-admin/ApiKeysView';

export default function ApiKeysPage() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold tracking-tight">API Keys & Settings</h2>
        <p className="text-muted-foreground">
          Manage external service API credentials
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>API Keys Management</CardTitle>
          <CardDescription>
            Configure API keys for external service integrations.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <ApiKeysView />
        </CardContent>
      </Card>
    </div>
  );
}
